import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";
import { useContext } from "react";
import { ScreenContext } from "../context/ScreenContext";
import { useLocation, useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";

const CustomDescrip = ({
  key,
  title,
  description,
  question,
  img,
  reverse = false,
  questionto,
}) => {
  const location = useLocation();

  const { isMobile } = useContext(ScreenContext);
  const navigate = useNavigate();

  const handleWhatsApp = () => {
    trackEvent(question, {
      page_path: location.pathname,
      page_url: window.location.href,
      section: `${question}_WhatsApp`,
      cta_name: "enviar_mensaje",
      value: 1,
    });

    openWhatsApp(
      "525959570961",
      `Hola Centro Médico MEDAM 👋, tengo algunas dudas y me gustaría recibir información.`,
      true,
    );
  };

  return (
    <Grid container key={key} width="100%">
      <Grid size={design.Grid1} />
      <Grid container size={design.Grid10} pt={3}>
        {reverse && (
          <Grid size={design.Grid6} sx={design.alignContent}>
            <ImageLoader
              src={img}
              alt={title}
              width={"95%"}
              height={isMobile ? 200 : 400}
              borderRadius={3}
            />
          </Grid>
        )}
        <Grid
          size={design.Grid6}
          sx={design.alignContent}
          onClick={() => {
            if (questionto.startsWith("http")) {
              window.open(questionto, "_blank", "noopener,noreferrer");
            } else {
              navigate(questionto);
            }
          }}
        >
          <CustomText
            variant="subtitle1"
            color="#2349D0"
            text={title}
            sx={design.Titulo}
          >
            {title}
          </CustomText>
          {description}
          <CustomText
            variant="subtitle1"
            color="#2349D0"
            text={question}
            sx={design.Pregunta}
            onClick={handleWhatsApp}
          >
            {question}
          </CustomText>
        </Grid>
        {!reverse && (
          <Grid size={design.Grid6} sx={design.alignContent} pt={isMobile && 2}>
            <ImageLoader
              src={img}
              alt={title}
              width={"95%"}
              height={isMobile ? 200 : 400}
              borderRadius={3}
            />
          </Grid>
        )}
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};

export default CustomDescrip;

const design = {
  alignContent: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  Titulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    lineHeight: "normal",
    textAlign: "left",
    paddingTop: 2,
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    textAlign: "left",
  },
  Pregunta: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    lineHeight: "normal",
    textAlign: "left",
    marginTop: 5,
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid6: { xs: 12, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 10, md: 10, xl: 10, lg: 10 },
};
